import { render } from "./ModalUpdateProfile.vue?vue&type=template&id=d23f09c6&scoped=true"
import script from "./ModalUpdateProfile.vue?vue&type=script&lang=js"
export * from "./ModalUpdateProfile.vue?vue&type=script&lang=js"

import "./ModalUpdateProfile.vue?vue&type=style&index=0&id=d23f09c6&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d23f09c6"]])

export default __exports__